import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { RewardDetails } from './RewardDetails';

export class RewardDetailsResource extends FBaseService {
  public async getRewardDetails(fiId: string, cycleId: number, externalProductMappingId: string, akk: string)
    : Promise<RewardDetails | null> {
    try {
      const response: AxiosResponse = await this.apiClient.get(
        `/api/rcx/reporting/${fiId}/reward-details/by-key/${cycleId}/${externalProductMappingId}/${akk}`,
      );
      const results: RewardDetails = response.data.data;
      return results;
    } catch (error) {
      if (error.response.status === 404) {
        return null;
      }
      throw error;
    }
  }
}

export default RewardDetailsResource;
